import './App.css';

import MainPageProfile from '../MainPageProfile/MainPageProfile';
import { AuthProvider } from '../../Context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <div className="App__container">
          <MainPageProfile />
        </div>
      </div>
    </AuthProvider>
  );
}

export default App;